import { $isInIos } from '@/util/util'
import store from '@/store/index'

export default {
  // 调用原生接口，跳转至原生登录页
  turnToAppLoginPage: (toastCallback) => {
    if ($isInIos()) {
      if (window.iOSApp.getAppUserInfo().cur_version < window.h5ConfigDetails[0]['activitySetting']['appVersionIos']) {
        toastCallback('请升级APP版本至最新版')
      } else {
        window.webkit.messageHandlers.Share.postMessage({
          eventName: 'jumpToLoginVc'
        })
      }
    } else {
      window.webapp.turnToActivity(16)
      // window.webapp.turnToActivity(-1) 登录后自动返回
    }
  },
  // 调用原生接口，退出webview
  exitWebView: (needReAuth) => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'gm_quit_fullscreen_web'
      })
    } else {
      // 点击导航栏部分触发webapp.needReAuth()接口在APP重新鉴权的逻辑（手势和系统back可以触发），所以此处需要包含该场景（立即鉴权）
      needReAuth && window.webapp.reAuthByH5()
      window.setTimeout(() => {
        window.webapp.turnToActivity(-1)
      }, 100)
    }
  },
  // 调用原生接口，退出webview
  exitModal: () => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'gm_quit_fullscreen_web'
      })
    } else {
      window.webapp.close()
    }
  },
  // 调用原生接口，退出APP时，刷新app token。作用：例如保障用户vip时间更新
  refreshAppToken: () => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'refreshToken'
      })
    } else {
      window.webapp.needReAuth()
    }
  },
  // 调用原生接口，上报埋点至友盟
  reportEventByApp: (eventName, eventObj, type = 2) => {
    try {
      if ($isInIos()) {
        // 补丁：
        // IOS 4.7.4版本前，type参数上传有误，会导致埋点属性无法正常解析，但是如果统一修改又会导致线上版本埋点无法上报
        // 为不影响线上版本修改参数后报错导致埋点不上报；
        // 本版本后（增加了新接口），开始传2，之前的版本将错就错
        let type2 = window.iOSAppGlobal ? type : 1
        window.webkit.messageHandlers.Share.postMessage({
          eventName: 'UMMobClick', // 这个事件名是ios通信得事件名
          type: type2, // 0:无内容 ; 1:label ; 2: attr
          key: eventName, // 这个事件名是埋点上报的事件名
          content: JSON.stringify(eventObj)
        })
      } else {
        window.webapp.reportEventParam(eventName, JSON.stringify(eventObj))
      }
    } catch (error) {
      console.log('埋点上报失败')
    }
  },
  notifyTagVisibleToApp: () => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'alertDisplayFinished'
      })
    } else {
      window.webapp.alertDisplayFinished()
    }
  },
  // 跳转到系统设置页，目前只有andriod使用
  turnToSystemBatteryPage: () => {
    if (!$isInIos()) {
      window.webapp.turnToSystemBatteryPage()
    }
  },
  startPay: (data, userInfo) => {
    console.log(data, 'data.partnerId')
    store.commit('SET_CLICK_BOTTOM_BUY_BTN')

    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'purchaseIAPProduct',
        partnerId: data.partnerId,
        partnerIdsWithGroup: data.partnerIdsWithGroup[userInfo.appUserGroup] || '',
        productId: data.productId,
        userId: userInfo.userId || ''
      })
    } else {
      window.webapp.startPay(data.productId)
    }
  },
  getProductList: (callback) => {
    if ($isInIos()) {
      try {
        window.onGetAppProducts = function (productListJsonStr) {
          callback && callback(JSON.parse(productListJsonStr))
        }
        window.webkit.messageHandlers.Share.postMessage({
          eventName: 'showProductStoreInH5'
        })
      } catch (error) {
        console.log('iOS请求产品列表失败')
      }
    } else {
      let productList = JSON.parsewebapp.getProductList()
      callback && callback(productList)
    }
  },
  // 获取app版本号
  getAppVersionCode: function () {
    if ($isInIos()) {
      return window.iOSApp.getAppUserInfo().cur_version || 0
    } else {
      return window.webapp.getAppVersionCode() > 10000 ? window.webapp.getAppVersionCode() - 10000 : window.webapp.getAppVersionCode()
    }
  },
  /**
   * 退出webview
   */
  closeWebView: function () {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'gm_quit_fullscreen_web'
      })
    } else {
      window.webapp.turnToActivity(-1)
    }
  },
  /**
  * 跳转加速首页
  */
  jumpToAccelPage () {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'jumpToAccelVc'
      })
    } else {
      window.webapp.turnToActivity(4)
    }
  },
  // 主机版本
  getProductABTestPlan () {
    try {
      return window.webapp.getProductABTestPlan()
    } catch (e) {
      return 'A'
    }
  },
  shareByApp (shareTitle, shareContent, shareIcon, shareUrl) {
    // shareIcon = "http://pic.xunyou.mobi/icon/boxshare.png"

    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({ 
        eventName: "shareInApp",
        title: shareTitle,
        content: shareContent,
        icon:shareIcon,
        url: shareUrl,
        popup_source:"2022_year_end_summary",
        cur_version: "4.5.0", // 只对录入版本限制（默认可不填） 
        mini_version: "4.5.0", // 最小版本限制，包括录入版本 （优先使用）
        isLandscape: "false", // 只有true时才是横屏展示，整个字段不填或者非true为默认竖屏分享
        webControl: "true" // 只有true时才是使用当前H5传递内容
      });
    } else {
      window.webapp.customShare(JSON.stringify({
        title: shareTitle,
        content: shareContent,
        iconUrl: shareIcon,
        shareUrl: shareUrl,
        useOriginPic: true,
        popupSource:"year_end_summary_2022"
      }))
    }
  },
  /**
   * 加速游戏
   */
  startAcc: (gameUid, from = 'blindbox') => {
    if ($isInIos()) {
      // window.webkit.messageHandlers.Share.postMessage({
      //   eventName: 'startAcc',
      //   gameUid,
      //   from
      // })
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'jumpToAccelVc',
        gameUid
      })
    } else {
      window.webapp.startAcc(gameUid, from)
    }
  },
  /**
   * 判断本地是否安装了该游戏
   * @param {*} packageName 
   * @returns 
   */
  isInstallGame: (packageName) => {
    if (!$isInIos()) {
      const localGameList = JSON.parse(window.webapp.getLocalGameList())
      return localGameList.some((game) => {
        return game.packageName === packageName
      })
    }

    return true
  },

  // 通过app跳转至外部浏览器并加载URL
  turnToWeb: (url) => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'jumpToExternalBrowser',
        target_url: url
      })
    } else {
      window.webapp.turnToWeb(url, true)
    }
  },

  // 跳转AI加速套餐购买页
  turnToAI: () => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'jumpToAIAccelVipPage'
      })
    } else {
      window.webapp.turnToActivity(31)
    }
  },

  // 跳转蓝兔套餐购买页
  turnToBlueBunnyVipPage: () => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'jumpToBlueVipPage'
      })
    } else {
      window.webapp.turnToActivity(32)
    }
  },

  // 跳转蓝兔Plus套餐购买页
  turnToBlueBunnyPlusPage: () => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'jumpToBluePlusPage'
      })
    } else {
      window.webapp.turnToActivity(34)
    }
  },

  // 跳转工具会员套餐购买页
  turnToxNationalVipPage: () => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'jumpToToolsVipPage'
      })
    } else {
      window.webapp.turnToActivity(33)
    }
  },

  // 跳转到智齿客服页面，目前只有andriod使用
  turnToAppZhiChiPage: () => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: "openZCChat"
      })
    } else {
      window.webapp.turnToActivity(19)
    }
  },
  // 打开APP内部webview
  appToWebPlus: (url, navTitle) => {
    if ($isInIos()) {
      if (navTitle) {
        window.webkit.messageHandlers.Share.postMessage({
          eventName: 'jumpToH5',
          url: url,
          reload: true,
          navTitle: navTitle
        })
      } else {
        window.webkit.messageHandlers.Share.postMessage({
          eventName: 'jumpToH5',
          url: url,
          reload: true
        })
      }
    } else {
      if (navTitle) {
        window.webapp.turnToWebActivityParam(18, url, JSON.stringify({title: navTitle}))
      } else {
        window.webapp.turnToWebActivityParam(22, url, '')
      }
    }
  },
  // 调用绑定livelink账号
  bindLiveLinkAccount: () => {
    window.eventBus.$emit('onBindLiveLink', true)

    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'bindLiveLinkAcount'
      })
    } else {
      window.webapp.doBindWxLiveLink()
    }
  },
  // 打开APP内部webview
  appToWeb: (url) => {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'jumpToH5',
        url: url,
        reload: true
      })
      // 打开iOS内部webview
    } else {
      //22 全屏 25沉浸式
      window.webapp.turnToWebActivityParam(25, url) 
      // window.webapp.turnToWeb(url, false)
    }
  },

  /**
 * 调用客户端完成任务 22:激励视频
 */
  finishTask: function (taskId, action) {
    if ($isInIos()) {
      window.webkit.messageHandlers.Share.postMessage({
        eventName: 'doTask',
        taskId,
        action
      })
    } else {
      window.webapp.doTask(taskId, action)
    }
  },
  /**
 * 需要中断返回
 */
  needInterruptBack: function () {
    try {
      if (!$isInIos()) {
        window.webapp.needInterruptBack()
      }
    } catch (error) {
      console.log('旧版本不支持拦截')
    }
  }
}
